import { storyblokEditable, renderRichText } from "@storyblok/react";
import { NotebookPen } from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router";

export const FeaturedArticles = ({ blok }) => {
  return (
    <section {...storyblokEditable(blok)} className="featured-articles">
      <div className="featured-articles-intro">
        <div className="case-studies-icon-wrapper">
          <NotebookPen className="cs-icon" size={24} />
          Case studies
        </div>
        <h2>
          Real Stories. <br />
          Real Impact. <br />
          Real Results.
        </h2>
        <p>
          These case studies aren't just success stories. They're proof that
          when passionate changemakers meet the right tools, extraordinary
          things happen. Each story represents a moment when potential
          transformed into power, when communities stopped waiting for change
          and started creating it.
        </p>
        <a href="/case-studies" className="button button-primary">
          View all case studies{" "}
          <ArrowRight size={24} fill="white" className="button-icon" />
        </a>
      </div>
      <ul className="home-case-studies">
        {blok.articles.map((article) => (
          <li key={article.uuid}>
            <div className="article-meta">
              <div className="image-wrap">
                <img src={article.content.largeimage.filename} />
              </div>
              <h4>{article.name}</h4>

              <p>{article.content.subtitle}</p>
              <Link to={`/${article.full_slug}`} className="articlelink">
                {/* {article.name} */}Read more
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
